export const getDistinctCountries = (locations) => {
    let countries = [];
    for (let i = 0; i < locations.length; i++) {
        let country = locations[i].Country;
        if (!countries.includes(country))
            countries.push(country);
    }
    
    return countries.sort();
}

